// removed by extract-text-webpack-plugin
module.exports = {"main":"#1A2C5A","large_desktop":"only screen and (min-width: 1201px)","desktop":"only screen and (min-width: 1025px) and (max-width: 1200px)","tablet":"only screen and (min-width: 768px) and (max-width: 1024px)","mobile":"only screen and (max-width: 767px)","lookingForTheFuture":"lookingForTheFuture__2gnyD","futureText":"futureText__3cLmG","subTitleBlock":"subTitleBlock__2TkzA"};


//////////////////
// WEBPACK FOOTER
// ./components/LookingForTheFuture/style.css
// module id = Cr5C
// module chunks = 0